import {
  useTheme,
  ToggleButtonGroup,
  ToggleButton,
  Typography,
} from "@mui/material"
import SavedSearchRoundedIcon from "@mui/icons-material/SavedSearchRounded"
import { useParams } from "react-router-dom"
import { useMemo, useRef, useCallback, useEffect } from "react"
import { useTranslation } from "providers/i18n"
import { useVenue } from "providers/venue"
import _ from "lodash"
import { getIcon } from "utils/icon"

export const AmenityChipToggleGroup = (props) => {
  const { amenities = [], handleClickAmenity = () => {} } = props
  const { t } = useTranslation()
  const theme = useTheme()
  const { mapTheme } = useVenue()

  const { root, button, text } =
    theme.components[`AmenityChipToggleGroup`]?.styleOverrides || {}
  const { category } = useParams()

  const scrollRef = useRef([])
  const scrollToSection = useCallback((index) => {
    if (scrollRef.current.length) {
      scrollRef.current[index]?.scrollIntoView({ behavior: "smooth" })
    }
  }, [])

  useEffect(() => {
    if (category && amenities.length) {
      const index = amenities.indexOf(category)
      scrollToSection(index)
    }
  }, [scrollToSection, category, amenities])

  const getAmenityButtonProps = useCallback(
    (amenityCategory) => {
      const iconPath = _.get(
        mapTheme,
        `amenity.${amenityCategory}.label.marker.symbol.markerPath`
      )
      const image = _.get(
        mapTheme,
        `amenity.${amenityCategory}.label.marker.symbol.markerFile`
      )
      return iconPath
        ? { category: amenityCategory, icon_path: iconPath }
        : { category: amenityCategory, image }
    },
    [mapTheme]
  )

  const amenityButtonProps = useMemo(
    () => amenities.map((amenity) => getAmenityButtonProps(amenity)),
    [amenities, getAmenityButtonProps]
  )
  return (
    <ToggleButtonGroup color="primary" value={category} exclusive sx={root}>
      {amenityButtonProps.map((amenity, index) => {
        return (
          <ToggleButton
            key={`amenity-quick-search-${amenity.category}`}
            value={amenity.category}
            sx={button}
            onClick={() => {
              handleClickAmenity(amenity.category)
            }}
            ref={(ref) => (scrollRef.current[index] = ref)}
          >
            {getIcon(amenity) || <SavedSearchRoundedIcon />}
            <Typography variant="subtitle" component="span" sx={text}>
              {t(`amenity.${amenity.category}`, { ns: "imdf" })}
            </Typography>
          </ToggleButton>
        )
      })}
    </ToggleButtonGroup>
  )
}
